const tr = {
  sales: {
    tabs: {
      epay: 'Epay',
    },
  },
};
  
export default tr;
